// extracted by mini-css-extract-plugin
export default {"default":"full-widget-container-module__default___onE1d"};